import { render, staticRenderFns } from "./fieldDMCheckbox.vue?vue&type=template&id=6879bd48"
import script from "./fieldDMCheckbox.vue?vue&type=script&lang=js"
export * from "./fieldDMCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6879bd48')) {
      api.createRecord('6879bd48', component.options)
    } else {
      api.reload('6879bd48', component.options)
    }
    module.hot.accept("./fieldDMCheckbox.vue?vue&type=template&id=6879bd48", function () {
      api.rerender('6879bd48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/forms/fieldDMCheckbox.vue"
export default component.exports